var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 298,
    viewBox: "0 0 442 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2305_19840)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.207031,
    y: -1.11719,
    width: 446,
    height: 300,
    rx: 19.4105,
    fill: "#EF5555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.882 -70.403C158.407 -76.6345 200.311 -81.9009 229.959 -58.0697C261.525 -32.6972 272.285 10.5103 271.926 51.0073C271.571 91.1323 256.321 129.699 228.043 158.168C199.67 186.734 161.084 205.284 120.882 203.075C82.4164 200.962 52.6296 173.732 24.8843 147.005C-3.61813 119.55 -41.0533 90.3728 -36.9835 51.0073C-33.0055 12.5282 12.2092 -3.41823 42.8736 -27.0014C67.3944 -45.8597 90.3663 -65.3354 120.882 -70.403Z",
    fill: "#0D0606",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6872 41.0067C78.8581 44.8544 75.1855 104.514 102.37 130.155C131.462 157.595 188.939 152.565 200.537 190.838C212.816 231.362 189.506 279.555 155.135 304.286C123.224 327.248 80.884 308.165 41.6872 305.14C7.5913 302.508 -34.7396 315.201 -55.5055 288.031C-76.0614 261.135 -50.065 224.403 -45.6721 190.838C-42.2652 164.807 -46.2328 138.821 -33.0093 116.141C-14.5174 84.4256 5.16927 37.2266 41.6872 41.0067Z",
    fill: "#0D0606",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.571 65.5216C295.279 59.2777 334.352 69.3601 357.75 95.7454C380.387 121.271 373.478 158.808 373.554 192.925C373.63 227.167 382.874 266.813 358.183 290.538C333.64 314.121 294.511 304.051 260.571 301.49C230.349 299.21 200.804 295.153 176.655 276.841C148.29 255.332 113.575 228.317 117.4 192.925C121.175 157.992 166.775 148.737 193.024 125.379C216.387 104.588 229.79 71.0588 260.571 65.5216Z",
    fill: "#1B0F0F",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2305_19840"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.207031,
    y: -1.11719,
    width: 446,
    height: 300,
    rx: 19.4105,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.c954b952a5b5bb6fb332be317b216407.svg";
export { ForwardRef as ReactComponent };